/**
 * 检测本次会话是否丢失 sort
 * 指令丢失  创建会话指令 欢迎语
 * 尾部丢失 即最后一条消息体丢失
 * sort按每个消息递增的方式返回
 * @param uncheckMessages  待检测的sort
 * @param curMaxSort 当前会话最新消息的sort
 */
export const getLostMessages = (uncheckMessages, curMaxSort = 0) => {
  console.log("uncheckMessages");

  let lostSorts = []; //丢失消息体的 sort 集合
  const index = 0;

  // 本次会话

  let currMsg = uncheckMessages
    .slice(index)
    .sort((pre, next) => pre.sort - next.sort);

  let maxSort = currMsg[currMsg.length - 1].sort;

  checkLastMessage();
  checkMiddleMessage();
  checkFirstMessage();

  return {
    lostSorts
  };

  // 最后一条消息不匹配 拉取本次的最新消息
  // chatCusServerDetail 表示当前会员的最后一条信息
  function checkLastMessage() {
    if (currMsg.length > 0 && maxSort < curMaxSort) {
      for (let i = maxSort.sort + 1; i <= curMaxSort; i++) {
        lostSorts.push(i);
      }
    }
  }

  // 检测中间是否存在 sort 衔接不上 => 消息丢失
  // 相邻的消息的sort可能有相对的情况
  function checkMiddleMessage() {
    currMsg.forEach((item, index) => {
      // item.sort当前的sort 加 1 ，应该和下一个消息的sort相同，如果不相同就是有消息丢失
      if (
        index < currMsg.length - 1 &&
        item.sort + 1 != currMsg[index + 1].sort
      ) {
        // 处理只丢失一个sort
        if (currMsg[index + 1].sort - item.sort == 2) {
          lostSorts.push(item.sort + 1);
        } else {
          //处理两个消息中间丢失多个sort
          for (let i = item.sort + 1; i < currMsg[index + 1].sort; i++) {
            lostSorts.push(i);
          }
        }
      }
    });
  }

  // 首个消息体是否丢失，比如首个消息的sort是5， 那就丢失了 1，2，3，4这四个消息
  function checkFirstMessage() {
    if (uncheckMessages[index].sort != 1) {
      for (let i = 1; i < currMsg[0].sort; i++) {
        lostSorts.push(i);
      }
    }
  }
};

/**
 * 设置当前会话最新时间搓
 * 用于判断当前tab标签是否最新tab会话
 */
export const setSessionTimeCache = userId => {
  const nowMs = Date.now() + "";
  sessionStorage.setItem("tabSessionTime_" + userId, nowMs);
  localStorage.setItem("tabSessionTime_" + userId, nowMs);
  console.log("====set tabSessionTime====");
};

export const getSessionTimeCache = userId => {
  return {
    sessionTime: sessionStorage.getItem("tabSessionTime_" + userId),
    localTime: localStorage.getItem("tabSessionTime_" + userId)
  };
};

export const canAcceptThisMessage = userId => {
  const { sessionTime, localTime } = getSessionTimeCache(userId);
  const canAccept = sessionTime === localTime;
  console.log("canAcceptThisMessage:", canAccept);
  return canAccept;
};
